import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addDraftOrder } from "../../slices/draftOrders/reducer";
import { createDraftOrder } from "../../helpers/backend_helper";

const FloatingOrderButton = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const ordersState = useSelector((state: any) => state.draftOrders?.orders);
    const orders = Array.isArray(ordersState) ? ordersState : [];

    const handleCreateOrder = async () => {
        try {
            const response = await createDraftOrder();
            const payload = (response && typeof response === "object" && "data" in response)
                ? (response as any).data
                : response;
            const orderId = payload?.id ?? payload?.orderId;
            const createdAt = payload?.createdAt ?? payload?.created_at ?? new Date().toISOString();
            if (orderId) {
                dispatch(addDraftOrder({ id: orderId, createdAt }));
                navigate(`/order/${orderId}`);
            }
        } catch (error) {
            console.error("Failed to create order", error);
        }
    };

    return (
        <div className="btn-group dropup position-fixed bottom-0 end-0 m-4">
            <button onClick={handleCreateOrder} className="btn btn-primary">
                Tạo order
            </button>
            <button
                type="button"
                className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <span className="visually-hidden">Toggle Dropdown</span>
            </button>
            <ul className="dropdown-menu overflow-auto max-h-200">
                {orders.length === 0 && (
                    <li className="text-center text-muted px-4">
                        Không có order nháp
                    </li>
                )}
                {orders.map((order: any) => (
                    <li key={order.id}>
                        <button
                            className="dropdown-item"
                            onClick={() => navigate(`/order/${order.id}`)}
                        >
                            {order.id} - {new Date(order.createdAt).toLocaleString()}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FloatingOrderButton;
